function Croatia({ dimensions, col = '#000' }) {
  const baseXml = `
  <svg width=${dimensions || 24} height=${dimensions || 24} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
  <g clip-path="url(#clip0_521_991)">
  <path d="M32 15.9992C32 14.042 31.6479 12.1672 31.0048 10.434L16 9.73828L0.995188 10.4339C0.352063 12.1672 0 14.042 0 15.9992C0 17.9563 0.352063 19.8311 0.995188 21.5643L16 22.26L31.0048 21.5644C31.6479 19.8311 32 17.9563 32 15.9992Z" fill="#F0F0F0"/>
  <path d="M16 31.9993C22.8795 31.9993 28.7442 27.6573 31.0049 21.5645H0.995239C3.25593 27.6573 9.12061 31.9993 16 31.9993Z" fill="#0052B4"/>
  <path d="M0.995239 10.4348H31.0049C28.7442 4.342 22.8795 0 16 0C9.12061 0 3.25593 4.342 0.995239 10.4348Z" fill="#D80027"/>
  <path d="M20.174 11.1313H17.3914L17.8552 7.65303L19.7102 6.26172L21.5652 7.65303V10.4357L20.174 11.1313Z" fill="#338AF3"/>
  <path d="M11.8261 11.1313H14.6087L14.1449 7.65303L12.2898 6.26172L10.4348 7.65303V10.4357L11.8261 11.1313Z" fill="#338AF3"/>
  <path d="M17.8551 11.1313H14.1449V7.65303L16 6.26172L17.8551 7.65303V11.1313Z" fill="#0052B4"/>
  <path d="M10.4348 10.4355V18.0877C10.4348 19.9097 11.3149 21.5301 12.6724 22.5459L13.6464 22.3022L14.8754 23.5386C15.2388 23.6135 15.6149 23.6529 16.0001 23.6529C16.3832 23.6529 16.7574 23.614 17.1189 23.5399L18.5218 22.3717L19.3276 22.5437C20.6845 21.5279 21.5653 19.9092 21.5653 18.0877V10.4355H10.4348Z" fill="#F0F0F0"/>
  <path d="M10.4348 10.4355H12.6609V12.6616H10.4348V10.4355Z" fill="#D80027"/>
  <path d="M14.887 10.4355H17.113V12.6616H14.887V10.4355Z" fill="#D80027"/>
  <path d="M19.3391 10.4355H21.5652V12.6616H19.3391V10.4355Z" fill="#D80027"/>
  <path d="M12.6609 12.6621H14.887V14.8882H12.6609V12.6621Z" fill="#D80027"/>
  <path d="M17.113 12.6621H19.3391V14.8882H17.113V12.6621Z" fill="#D80027"/>
  <path d="M10.4348 14.8867H12.6609V17.1128H10.4348V14.8867Z" fill="#D80027"/>
  <path d="M12.6609 17.1133H14.887V19.3393H12.6609V17.1133Z" fill="#D80027"/>
  <path d="M14.887 14.8867H17.113V17.1128H14.887V14.8867Z" fill="#D80027"/>
  <path d="M19.3391 14.8867H21.5652V17.1128H19.3391V14.8867Z" fill="#D80027"/>
  <path d="M17.113 17.1133H19.3391V19.3393H17.113V17.1133Z" fill="#D80027"/>
  <path d="M14.887 19.3398H17.113V21.5659H14.887V19.3398Z" fill="#D80027"/>
  <path d="M12.6609 19.3398H10.5785C10.7695 20.1673 11.145 20.9245 11.6599 21.5659H12.6609V19.3398Z" fill="#D80027"/>
  <path d="M19.3391 21.5659H20.3401C20.8551 20.9245 21.2305 20.1673 21.4215 19.3398H19.3391V21.5659Z" fill="#D80027"/>
  <path d="M12.6609 21.5664V22.5377C13.3083 23.0249 14.065 23.3742 14.887 23.5418V21.5664H12.6609Z" fill="#D80027"/>
  <path d="M17.113 21.5664V23.5418C17.9351 23.3743 18.6917 23.0249 19.3391 22.5377V21.5664H17.113Z" fill="#D80027"/>
  </g>
  </svg>
  `;

  return baseXml;
}

export default Croatia;
